/**
 * Payments — bank details shown on invoices and payment instructions.
 * Plain data rows (per-row blur commit); the quote studio preview renders
 * them in context.
 */
import { TextSettingRow } from "../../components/ui/SettingRow";
import type { SectionProps } from "./GeneralSection";
import { SectionHeader } from "./section-chrome";
import chrome from "./settings.module.css";

export function PaymentsSection({ settings, onPatch }: SectionProps) {
  return (
    <section className={chrome.section}>
      <SectionHeader
        title="Payments"
        description="Bank details shown on invoices and payment instructions."
      />
      <TextSettingRow
        id="payment-account-name"
        title="Account name"
        value={settings.payment_account_name}
        onSave={(payment_account_name) => onPatch({ payment_account_name })}
      />
      <TextSettingRow
        id="payment-bank-name"
        title="Bank"
        value={settings.payment_bank_name}
        onSave={(payment_bank_name) => onPatch({ payment_bank_name })}
      />
      <TextSettingRow
        id="payment-account-number"
        title="Account number"
        value={settings.payment_account_number}
        onSave={(payment_account_number) => onPatch({ payment_account_number })}
      />
    </section>
  );
}
